import {calcUsedConstructionActions} from "./calcUsedConstructionActions";

export const checkIfHasRemainingConstructionActions = (currentPlayer, pendingBuildings, nextInitiativePlayerId, isInitiativeInterceptedWithIsolationism) => {
  return currentPlayer.constructionPhaseActions > calcUsedConstructionActions(currentPlayer, pendingBuildings, nextInitiativePlayerId, isInitiativeInterceptedWithIsolationism);
}